import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Api from "../../../../constants/Api";
import MenuConfig from "../../../../constants/MenuConfig";
import { getId, sendToApi } from "../../../../utils/ApiUtils";
import { convertBooleanToStatus } from "../../../../utils/ConverterUtils";
import { ApiError } from "../../../components/Common/ApiError";
import NewPage from "../../../layouts/page/NewPage";
import PerformancePlanForm from "./PerformancePlanForm";

const PerformancePlanNew = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [status, setStatus] = useState(true);
    const [entityData, setEntityData] = useState(null);

    const formik = useFormik({
        initialValues: {
            name: "",
            description: "",
            evaluationPeriodType: "MONTHLY",
            levels: [],
            indicators: []
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().required(t('validation.required.name')),
            levels: Yup.array().min(1, t('performance.validation.level_required'))
        }),
        onSubmit: values => {
            const payload = {
                id: getId(entityData),
                name: values.name,
                description: values.description,
                evaluationPeriodType: values.evaluationPeriodType,
                status: convertBooleanToStatus(status),
                levels: values.levels.map(level => ({
                    ...level,
                    status: convertBooleanToStatus(true)
                })),
                indicators: values.indicators.map(ind => ({
                    name: ind.name,
                    type: ind.type,
                    required: ind.required,
                    categoryId: ind.categoryId,
                    goals: (ind.goals || []).map(g => ({
                        levelOrder: g.levelOrder,
                        targetValue: g.targetValue
                    }))
                }))
            };

            sendToApi(Api.performance.plan, payload, () => {
                navigate(MenuConfig.performance.plan.route);
            }, (error) => {
                ApiError(error);
                formik.setSubmitting(false);
            });
        }
    });

    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    };

    return (
        <NewPage
            motherMenu={t('performance.label')}
            childMenu={t('performance.plans')}
            activeMenu={t('new')}
            child={<PerformancePlanForm formik={formik} status={status} setStatus={setStatus} entityData={entityData} />}
            setEntityData={setEntityData}
            path={Api.performance.plan}
            isSubmitting={formik.isSubmitting}
            handleSubmit={onSubmit}
            cancelRoute={MenuConfig.performance.plan.route}
        />
    );
}

export default PerformancePlanNew;
